import { Link } from 'react-router-dom';
import { navigationLinks, socialLinks } from '../assets/siteData';
import brandLogo from '../assets/logo11.png';

export function Footer() {
  return (
    <footer className="footer shell">
      <div className="footer__panel glass-panel">
        <div className="footer__grid">
          <div>
            <img className="brand__logo brand__logo--footer" src={brandLogo} alt="VappyTech logo" />
            <p className="eyebrow">Arjun Sharma</p>
            <h2 className="footer__title">Developer, founder, educator, and future-tech builder.</h2>
            <p className="footer__text">
              Premium digital experiences for client work, startup vision through VappyTech, and practical education through Udann Computer Coaching.
            </p>
          </div>
          <div>
            <p className="footer__label">Pages</p>
            <div className="footer__links">
              {navigationLinks.map((item) => (
                <Link key={item.path} to={item.path}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <p className="footer__label">Social</p>
            <div className="footer__links">
              {socialLinks.map((item) => (
                <a key={item.label} href={item.href} target="_blank" rel="noreferrer">
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          {/* <span>Premium portfolio UI crafted in React + pure CSS.</span> */}
          <span>© 2026 Arjun Sharma</span>
        </div>
      </div>
    </footer>
  );
}